export function shouldResetSessionHistory(localLatestMsgId, remoteLatestMsgId) {
  return localLatestMsgId > 0
    && remoteLatestMsgId > 0
    && localLatestMsgId > remoteLatestMsgId;
}

export function resolveIncomingUnreadCount({
  sessionKey,
  currentSessionKey,
  previousUnreadCount,
  isEcho = false,
}) {
  if (sessionKey === currentSessionKey) {
    return 0;
  }
  return previousUnreadCount + (isEcho ? 0 : 1);
}

export function resolveSyncedUnreadCount({
  sessionKey,
  currentSessionKey,
  remoteUnreadCount,
}) {
  if (sessionKey === currentSessionKey) {
    return 0;
  }
  return remoteUnreadCount;
}

export function resolveDirectMessageSessionId({
  ownerUserId,
  fromUserId,
  toSessionId,
}) {
  const ids = [ownerUserId, fromUserId, toSessionId];
  if (!ids.every((value) => Number.isSafeInteger(value) && value > 0)) {
    return null;
  }
  if (ownerUserId !== fromUserId && ownerUserId !== toSessionId) {
    return null;
  }
  return ownerUserId === fromUserId ? toSessionId : fromUserId;
}
